/**
 * Temu 尺码表分类 classId ↔ className（平台文档「尺码表分类」）。
 * 创建 / 列表展示共用；以平台映射为准，未知 id 回退为「分类#id」。
 */

export const TEMU_SIZE_CHART_CLASS_ENTRIES = [
  { classId: 3, className: '男上装' },
  { classId: 4, className: '男下装' },
  { classId: 5, className: '女上装' },
  { classId: 6, className: '女下装' },
  { classId: 7, className: '女连衣裙' },
  { classId: 8, className: '女童装' },
  { classId: 9, className: '文胸' },
  { classId: 11, className: '男鞋' },
  { classId: 12, className: '女鞋' },
  { classId: 13, className: '女童鞋' },
  { classId: 14, className: '鞋子' },
  { classId: 15, className: '男套装' },
  { classId: 16, className: '女套装' },
  { classId: 17, className: '男女套装' },
  { classId: 18, className: '女上装-大码' },
  { classId: 19, className: '女下装-大码' },
  { classId: 20, className: '女连衣裙-大码' },
  { classId: 21, className: '女套装-大码' },
  { classId: 23, className: '宠物配饰' },
  { classId: 25, className: '女袜' },
  { classId: 26, className: '男袜' },
  { classId: 27, className: '童袜' },
  { classId: 28, className: '女士短裙-常规' },
  { classId: 29, className: '女士外套-常规' },
  { classId: 30, className: '女士连体裤-常规' },
  { classId: 31, className: '女士紧身衣-常规' },
  { classId: 32, className: '女士内裤-常规' },
  { classId: 33, className: '女士连身泳衣-常规' },
  { classId: 34, className: '女士塑身衣-常规' },
  { classId: 35, className: '女士短裙-大码' },
  { classId: 36, className: '女士外套-大码' },
  { classId: 37, className: '女士连体裤-大码' },
  { classId: 38, className: '女士紧身衣-大码' },
  { classId: 39, className: '女士内裤-大码' },
  { classId: 40, className: '女士连身泳衣-大码' },
  { classId: 41, className: '女士塑身衣-大码' },
  { classId: 42, className: '男士外套' },
  { classId: 43, className: '男士连体裤' },
  { classId: 44, className: '男士内裤' },
  { classId: 45, className: '男下装-前后浪选填款' },
  { classId: 46, className: '男上装-大码' },
  { classId: 47, className: '男下装-大码' },
  { classId: 48, className: '男上装（背心）-大码' },
  { classId: 49, className: '男套装-大码' },
  { classId: 50, className: '猫狗服饰' },
  { classId: 51, className: '猫狗鞋袜' },
  { classId: 52, className: '上装-中性' },
  { classId: 53, className: '下装-中性' },
  { classId: 54, className: '连体裤-中性' },
  { classId: 55, className: '孕妇上装' },
  { classId: 56, className: '孕妇下装' },
  { classId: 57, className: '孕妇背心' },
  { classId: 58, className: '孕妇连衣裙' },
  { classId: 59, className: '孕妇套装' },
  { classId: 60, className: '大码男装内衣下装' },
  { classId: 61, className: '大码男装内裤' },
  { classId: 63, className: '男士大码内衣套装' },
  { classId: 64, className: '唐装汉服男上装' },
  { classId: 65, className: '唐装汉服男下装' },
  { classId: 66, className: '唐装汉服男其它' },
  { classId: 67, className: '唐装汉服男套装' },
  { classId: 71, className: '唐装汉服童其它' },
  { classId: 72, className: '唐装汉服女童套装' },
  { classId: 74, className: '腰带' },
  { classId: 75, className: '情趣男连体衣' },
  { classId: 76, className: '情趣男下装' },
  { classId: 77, className: '唐装汉服大码男下装' },
  { classId: 78, className: '其他大码男传统服装' },
  { classId: 79, className: '唐装汉服大码男套装' },
  { classId: 80, className: '女童装-下装' },
  { classId: 81, className: '女童装-上装' },
  { classId: 82, className: '女童装套装' },
  { classId: 83, className: '男上装（背心）' },
  { classId: 84, className: '女童装-连体衣' },
  { classId: 85, className: '女童装-马甲' },
  { classId: 86, className: '女童装-半身裙' },
  { classId: 87, className: '女童装-连衣裙' },
  { classId: 89, className: '床笠' },
  { classId: 95, className: '被套组' },
  { classId: 96, className: '床单组' },
  { classId: 97, className: '枕套组' },
  { classId: 98, className: '羽绒被/厚被' },
  { classId: 99, className: '薄被/床盖' },
  { classId: 102, className: '男内调节码' },
  { classId: 103, className: '床单床笠四件套' },
  { classId: 104, className: '羽绒被套三件套' },
  { classId: 105, className: '薄被三件套' },
  { classId: 106, className: '厚被三件套' },
  { classId: 107, className: '男童鞋' },
  { classId: 108, className: '男-裙子' },
  { classId: 109, className: '连裤袜' },
  { classId: 110, className: '孕妇半身裙' },
  { classId: 111, className: '男-牛仔' },
  { classId: 112, className: '大码孕妇-上装' },
  { classId: 113, className: '大码孕妇-下装' },
  { classId: 114, className: '大码孕妇背心' },
  { classId: 115, className: '大码孕妇内裤' },
  { classId: 116, className: '大码孕妇连衣裙' },
  { classId: 117, className: '大码孕妇半身裙' },
  { classId: 118, className: '大码孕妇连体衣' },
  { classId: 119, className: '大码孕妇套装' },
  { classId: 120, className: '孕妇内裤' },
  { classId: 122, className: '孕妇连体衣' },
  { classId: 123, className: '孕妇连体裤' },
  { classId: 124, className: '大码孕妇连体裤' },
  { classId: 125, className: '男童装' },
  { classId: 126, className: '唐装汉服童其它-男' },
  { classId: 127, className: '男童装-下装' },
  { classId: 128, className: '男童装-上装' },
  { classId: 129, className: '男童装-连体衣' },
  { classId: 130, className: '男童装-马甲' },
  { classId: 131, className: '唐装汉服男童套装' },
  { classId: 132, className: '男童装套装' },
  { classId: 133, className: '男上装（衬衫）' },
  { classId: 1003, className: '床上用品' },
  { classId: 1005, className: '吊袜带、吊袜腰带' },
  { classId: 1006, className: '挂毯、壁毯' },
  { classId: 1007, className: '女士情趣配件' },
  { classId: 1008, className: '收腹带' },
  { classId: 1010, className: '车罩' },
  { classId: 1013, className: '运动鞋鞋带尺码模板' },
  { classId: 1014, className: '枕头枕芯' },
  { classId: 1015, className: '被子类' },
  { classId: 1016, className: '床笠2' },
  { classId: 1017, className: '床单、被套类' },
  { classId: 1018, className: '窗帘类' },
  { classId: 1020, className: '男士内衣睡衣' },
  { classId: 1021, className: '男士塑身衣' },
  { classId: 1022, className: '宠物床具' },
  { classId: 1024, className: '浴袍毛巾' },
  { classId: 1025, className: '服饰' },
  { classId: 1026, className: '隐形文胸' },
  { classId: 1029, className: '枕头、枕芯' },
  { classId: 1030, className: '配饰-腰带' },
  { classId: 1031, className: '运动腰带' },
  { classId: 1032, className: '被套套装' },
  { classId: 1033, className: '女士饰品-戒指尺码' },
];

const NAME_BY_ID = new Map(
  TEMU_SIZE_CHART_CLASS_ENTRIES.map((e) => [Number(e.classId), e.className]),
);

/** @param {unknown} classId */
export function temuSizeChartClassName(classId) {
  const id = Number(classId);
  if (!(id > 0)) return '';
  return NAME_BY_ID.get(id) || `分类#${id}`;
}

/**
 * 归一化 sizeClass：补全 className，便于下拉与列表展示。
 * @param {unknown} sizeClass
 */
export function enrichTemuSizeChartClass(sizeClass) {
  if (!sizeClass || typeof sizeClass !== 'object') return null;
  const classId = Number(sizeClass.classId || 0);
  if (!(classId > 0)) return null;
  const mapped = temuSizeChartClassName(classId);
  const className = String(sizeClass.className || mapped || '').trim() || mapped;
  return {
    ...sizeClass,
    classId,
    className,
  };
}

/** 下拉选项：value=classId, label=「id · name」 */
export const TEMU_SIZE_CHART_CLASS_OPTIONS = TEMU_SIZE_CHART_CLASS_ENTRIES.map((e) => ({
  value: String(e.classId),
  label: `${e.classId} · ${e.className}`,
  classId: e.classId,
  className: e.className,
}));
